import marketing from "./user"

export const marketingReducers = {
  marketing: marketing.reducer
}
